import { SlidingRightPanelActions } from './actions';

import {
    SLIDING_RIGHT_PANEL_STATE
} from './types';

type SlidingRightPanelState = {
    isOpen: boolean,
    component: string,
    componentData: any
};

const INITIAL_STATE: SlidingRightPanelState = {
    isOpen: false,
    component: '',
    componentData: '',
};

export const reducer = (
    state = INITIAL_STATE,
    action: SlidingRightPanelActions
): SlidingRightPanelState => {

    switch (action.type) {

        case SLIDING_RIGHT_PANEL_STATE:
            return {
                ...state,
                isOpen: action.payload.isOpen,
                component: action.payload.currentComponent,
                componentData: action.payload.componentData
            };
        default:
            return state;
    }
};